import { Avatar, Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledSpan = styled("span")({
  opacity: 0.5
})

export const StyledBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  "& a": {
    backgroundColor: theme.palette.grey[100],
    padding: "20px 24px",
    borderRadius: 12,
    textDecoration: "none",
    color: theme.palette.secondary.main,
    display: "block"
  }
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.secondary.main
}))

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  background: theme.palette.green[200],
  color: theme.palette.green[900],
  "& span": {
    opacity: 1
  }
}))
